module.exports = __webpack_public_path__ + "static/media/Uploaded.e83c3873.svg";